import { Component, OnInit,Inject,Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Afiliado } from '../../models/afiliado/afiliado.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';

import { Usuario } from '../../models/usuario/usuario.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';

declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-afiliacion-tab6',
  templateUrl: '../../pages/afiliacion/afiliacion.tab6.html',
  styleUrls: ['../../pages/afiliacion/afiliacion.component.css']
})
export class AfiliacionTab6Component implements OnInit {

    rol:string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    @Input() afiliado: Afiliado;
    diasDiferencia: any;
    bancos: any;
    cursos: any[]; postulantes: any[];
    sistemaSalud: any

    escolaridad = { afiliado: "", beneficiario: "", etapaEscolar: "", fechaCertificado: "", email: "",
                  archivo: { bytes: null, tipo: null }, archivoTest: null }

    constructor(private router:Router, private escolaridadService:EscolaridadService,
        //        @Inject(MAT_DIALOG_DATA) public data: AfiliacionTab2Component, 
                private afiliacionService:AfiliacionService, private dialog: MatDialog,
                private mantenedorService: MantenedorUsuariosService) { }

    ngOnInit(): void
    {   
        let vm = this

    }

    guardar(){
        
    }
  
    seleccionaArchivo(event: any)
    {
        if(event.target.files.length > 0)
        {
            console.log(event.target.files[0].type)
            this.escolaridad.archivo.tipo = event.target.files[0].type

            let vm = this
            let reader = new FileReader()

            reader.readAsDataURL(event.target.files[0])

            reader.onload = function() {
                vm.escolaridad.archivo.bytes = reader.result

                console.log(vm.escolaridad.archivo.bytes)
            }
        }
    }
    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    salir()
    {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' }  }
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed) { this.router.navigate(['/index']); }
        });
    }
    soloNumeros(event: any) {
        // Obtenemos el valor actual del input
        let inputValue = event.target.value;
    
        // Removemos cualquier carácter que no sea un número usando una expresión regular
        inputValue = inputValue.replace(/[^0-9]/g, '');
    
        // Actualizamos el valor del input con solo números
        event.target.value = inputValue;
    }
}
